import { Node, Element, Transforms } from "slate";
const ejectElement = (editor, path) => {
  const element = Node.get(editor, path);
  if (!Element.isElement(element)) {
    return;
  }
  const { children, ...otherProperties } = element;
  Transforms.unsetNodes(editor, Object.keys(otherProperties), {
    at: path
  });
};
export {
  ejectElement
};
//# sourceMappingURL=ejectElement.js.map
